import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "../../../css/DesignSystem/Arrows/Arrows.css";

const ArrowLeft = ({ onClick, disabled }) => {
  const [clicked, setClicked] = useState(false);

  return (
    <div
      className={`Arrow-Container ${clicked ? "clicked" : ""}  ${
        disabled ? "disabled" : ""
      }`}
      onClick={() => {
        setClicked(!clicked);
        !disabled && onClick();
      }}
    >
      <IconButton className="Arrow-Icon" disableRipple>
        <ChevronLeftIcon className="Arrow-Icon" />
      </IconButton>
    </div>
  );
};

export default ArrowLeft;
